import gql from 'graphql-tag'

export default gql`
  mutation course_lessons_create_mutation($wistiaVideoId: String!) {
    courseLessonCreate(wistiaVideoId: $wistiaVideoId) {
      id
    }
  }
`
